import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-121f3d11"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "autoplay"]
const _hoisted_2 = { class: "controller" }
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = { class: "icon-content" }
const _hoisted_5 = { class: "volume" }
const _hoisted_6 = { class: "icon-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "thumb" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "ptime" }
const _hoisted_11 = { class: "dtime" }
const _hoisted_12 = { class: "bar" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "thumb" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { computed, ref } from 'vue'
import { message } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioPlayer',
  props: {
  src: {
    type: String,
    required: true,
  },
  loop: {
    type: Boolean,
    required: true,
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
  scale: {
    type: Number,
    default: 1,
  },
},
  setup(__props, { expose }) {

const props = __props



const secondToTime = (second = 0) => {
  if (second === 0 || isNaN(second)) return '00:00'

  const add0 = (num: number) => (num < 10 ? '0' + num : '' + num)
  const hour = Math.floor(second / 3600)
  const min = Math.floor((second - hour * 3600) / 60)
  const sec = Math.floor(second - hour * 3600 - min * 60)
  return (hour > 0 ? [hour, min, sec] : [min, sec]).map(add0).join(':')
}

const getBoundingClientRectViewLeft = (element: HTMLElement) => {
  return element.getBoundingClientRect().left
}

const audioRef = ref<HTMLAudioElement>()
const playBarWrap = ref<HTMLElement>()
const volumeBarRef = ref<HTMLElement>()

const volume = ref(0.5)
const paused = ref(true)
const currentTime = ref(0)
const duration = ref(0)
const loaded = ref(0)

const playBarTimeVisible = ref(false)
const playBarTime = ref('00:00')
const playBarTimeLeft = ref('0')

const ptime = computed(() => secondToTime(currentTime.value))
const dtime = computed(() => secondToTime(duration.value))
const playedBarWidth = computed(() => currentTime.value / duration.value * 100 + '%')
const loadedBarWidth = computed(() => loaded.value / duration.value * 100 + '%')
const volumeBarWidth = computed(() => volume.value * 100 + '%')

const seek = (time: number) => {
  if (!audioRef.value) return

  time = Math.max(time, 0)
  time = Math.min(time, duration.value)

  audioRef.value.currentTime = time
  currentTime.value = time
}

const play = () => {
  if (!audioRef.value) return

  paused.value = false
  audioRef.value.play()
}

const pause = () => {
  if (!audioRef.value) return

  paused.value = true
  audioRef.value.pause()
}

const toggle = () => {
  if (paused.value) play() 
  else pause()
}

const setVolume = (percentage: number) => {
  if (!audioRef.value) return

  percentage = Math.max(percentage, 0)
  percentage = Math.min(percentage, 1)

  audioRef.value.volume = percentage
  volume.value = percentage
  if (audioRef.value.muted && percentage !== 0) audioRef.value.muted = false
}

const handleDurationchange = () => {
  duration.value = audioRef.value?.duration || 0
}

const handleTimeupdate = () => {
  currentTime.value = audioRef.value?.currentTime || 0
}

const handlePlayed = () => {
  paused.value = false
}

const handleEnded = () => {
  if (!props.loop) pause()
  else {
    seek(0)
    play()
  }
}

const handleProgress = () => {
  loaded.value = audioRef.value?.buffered.length ? audioRef.value.buffered.end(audioRef.value.buffered.length - 1) : 0
}

const handleError = () => message.error('视频加载失败')

const thumbMove = (e: MouseEvent | TouchEvent) => {
  if (!audioRef.value || !playBarWrap.value) return
  const clientX = 'clientX' in e ? e.clientX : e.changedTouches[0].clientX
  let percentage = (clientX - getBoundingClientRectViewLeft(playBarWrap.value)) / playBarWrap.value.clientWidth
  percentage = Math.max(percentage, 0)
  percentage = Math.min(percentage, 1)
  const time = percentage * duration.value

  audioRef.value.currentTime = time
  currentTime.value = time
}

const thumbUp = (e: MouseEvent | TouchEvent) => {
  if (!audioRef.value || !playBarWrap.value) return

  const clientX = 'clientX' in e ? e.clientX : e.changedTouches[0].clientX
  let percentage = (clientX - getBoundingClientRectViewLeft(playBarWrap.value)) / playBarWrap.value.clientWidth
  percentage = Math.max(percentage, 0)
  percentage = Math.min(percentage, 1)
  const time = percentage * duration.value

  audioRef.value.currentTime = time
  currentTime.value = time

  document.removeEventListener('mousemove', thumbMove)
  document.removeEventListener('touchmove', thumbMove)
  document.removeEventListener('mouseup', thumbUp)
  document.removeEventListener('touchend', thumbUp)
}

const handleMousedownPlayBar = () => {
  document.addEventListener('mousemove', thumbMove)
  document.addEventListener('touchmove', thumbMove)
  document.addEventListener('mouseup', thumbUp)
  document.addEventListener('touchend', thumbUp)
}

const volumeMove = (e: MouseEvent | TouchEvent) => {
  if (!volumeBarRef.value) return
  const clientX = 'clientX' in e ? e.clientX : e.changedTouches[0].clientX
  const percentage = (clientX - getBoundingClientRectViewLeft(volumeBarRef.value)) / 45
  setVolume(percentage)
}

const volumeUp = () => {
  document.removeEventListener('mousemove', volumeMove)
  document.removeEventListener('touchmove', volumeMove)
  document.removeEventListener('mouseup', volumeUp)
  document.removeEventListener('touchend', volumeUp)
}

const handleMousedownVolumeBar = () => {
  document.addEventListener('mousemove', volumeMove)
  document.addEventListener('touchmove', volumeMove)
  document.addEventListener('mouseup', volumeUp)
  document.addEventListener('touchend', volumeUp)
}

const handleClickVolumeBar = (e: MouseEvent) => {
  if (!volumeBarRef.value) return
  const percentage = (e.clientX - getBoundingClientRectViewLeft(volumeBarRef.value)) / 45
  setVolume(percentage)
}

const handleMousemovePlayBar = (e: MouseEvent) => {
  if (duration.value && playBarWrap.value) {
    const px = playBarWrap.value.getBoundingClientRect().left
    const tx = e.clientX - px
    if (tx < 0 || tx > playBarWrap.value.offsetWidth) return

    const time = duration.value * (tx / playBarWrap.value.offsetWidth)
    playBarTimeLeft.value = `${tx - (time >= 3600 ? 25 : 20)}px`
    playBarTime.value = secondToTime(time)
    playBarTimeVisible.value = true
  }
}

const toggleVolume = () => {
  if (!audioRef.value) return

  if (audioRef.value.muted) {
    audioRef.value.muted = false
    setVolume(0.5)
  }
  else {
    audioRef.value.muted = true
    setVolume(0)
  }
}

expose({
  toggle,
})

return (_ctx: any,_cache: any) => {
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")!
  const _component_IconPause = _resolveComponent("IconPause")!
  const _component_IconVolumeMute = _resolveComponent("IconVolumeMute")!
  const _component_IconVolumeNotice = _resolveComponent("IconVolumeNotice")!
  const _component_IconVolumeSmall = _resolveComponent("IconVolumeSmall")!

  return (_openBlock(), _createElementBlock("div", {
    class: "audio-player",
    style: _normalizeStyle({ transform: `scale(${1 / __props.scale})` })
  }, [
    _createElementVNode("audio", {
      class: "audio",
      ref_key: "audioRef",
      ref: audioRef,
      src: __props.src,
      autoplay: __props.autoplay,
      onDurationchange: _cache[0] || (_cache[0] = ($event: any) => (handleDurationchange())),
      onTimeupdate: _cache[1] || (_cache[1] = ($event: any) => (handleTimeupdate())),
      onPlay: _cache[2] || (_cache[2] = ($event: any) => (handlePlayed())),
      onEnded: _cache[3] || (_cache[3] = ($event: any) => (handleEnded())),
      onProgress: _cache[4] || (_cache[4] = ($event: any) => (handleProgress())),
      onError: _cache[5] || (_cache[5] = ($event: any) => (handleError()))
    }, null, 40, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "icon play-icon",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (toggle()))
        }, [
          _createElementVNode("span", _hoisted_4, [
            (paused.value)
              ? (_openBlock(), _createBlock(_component_IconPlayOne, { key: 0 }))
              : (_openBlock(), _createBlock(_component_IconPause, { key: 1 }))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "icon volume-icon",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleVolume()))
          }, [
            _createElementVNode("span", _hoisted_6, [
              (volume.value === 0)
                ? (_openBlock(), _createBlock(_component_IconVolumeMute, { key: 0 }))
                : (volume.value === 1)
                  ? (_openBlock(), _createBlock(_component_IconVolumeNotice, { key: 1 }))
                  : (_openBlock(), _createBlock(_component_IconVolumeSmall, { key: 2 }))
            ])
          ]),
          _createElementVNode("div", {
            class: "volume-bar-wrap",
            onMousedown: _cache[8] || (_cache[8] = ($event: any) => (handleMousedownVolumeBar())),
            onTouchstart: _cache[9] || (_cache[9] = ($event: any) => (handleMousedownVolumeBar())),
            onClick: _cache[10] || (_cache[10] = $event => handleClickVolumeBar($event))
          }, [
            _createElementVNode("div", {
              class: "volume-bar",
              ref_key: "volumeBarRef",
              ref: volumeBarRef
            }, [
              _createElementVNode("div", {
                class: "volume-bar-inner",
                style: _normalizeStyle({ width: _unref(volumeBarWidth) })
              }, _hoisted_8, 4)
            ], 512)
          ], 32)
        ])
      ]),
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(ptime)), 1),
        _createTextVNode(" / "),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(dtime)), 1)
      ]),
      _createElementVNode("div", {
        class: "bar-wrap",
        ref_key: "playBarWrap",
        ref: playBarWrap,
        onMousedown: _cache[11] || (_cache[11] = ($event: any) => (handleMousedownPlayBar())),
        onTouchstart: _cache[12] || (_cache[12] = ($event: any) => (handleMousedownPlayBar())),
        onMousemove: _cache[13] || (_cache[13] = $event => handleMousemovePlayBar($event)),
        onMouseenter: _cache[14] || (_cache[14] = ($event: any) => (playBarTimeVisible.value = true)),
        onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (playBarTimeVisible.value = false))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["bar-time", { 'hidden': !playBarTimeVisible.value }]),
          style: _normalizeStyle({ left: playBarTimeLeft.value })
        }, _toDisplayString(playBarTime.value), 7),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "loaded",
            style: _normalizeStyle({ width: _unref(loadedBarWidth) })
          }, null, 4),
          _createElementVNode("div", {
            class: "played",
            style: _normalizeStyle({ width: _unref(playedBarWidth) })
          }, _hoisted_14, 4)
        ])
      ], 544)
    ])
  ], 4))
}
}

})